

























































































































































































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  inject,
  computed,
  onBeforeMount,
} from '@vue/composition-api'
import EditTextbookIssue from './components/TextbookIssue/EditTextbookIssue.vue'
import CreateTextbookIssue from './components/TextbookIssue/CreateTextbookIssue.vue'
import { TextbookIssue, Textbook } from '@/shared/types'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { previewLink } from '@/shared/api'
import { formatTimestamp, pagination } from '@/shared/utils'
import ImportTextbookIssue from './components/TextbookIssue/ImportTextbookIssue.vue'
import PreviewTextbookIssue from './components/TextbookIssue/PreviewTextbookIssue.vue'

import {
  CREATE_TEXTBOOK_ISSUE,
  EDIT_TEXTBOOK_ISSUE,
  DELETE_TEXTBOOK_ISSUE,
  PUBLISH_TEXTBOOK_ISSUE_LIVE,
  PUBLISH_TEXTBOOK_ISSUE_PREVIEW,
  IMPORT_TEXTBOOK_ISSUE,
  PREVIEW_TEXTBOOK_ISSUE,
} from '@/shared/user/permissions'
export default defineComponent({
  name: 'TextbookIssueOverview',
  components: {
    CreateTextbookIssue,
    EditTextbookIssue,
    ImportTextbookIssue,
    PreviewTextbookIssue,
  },
  setup(props, { root }) {
    const data = reactive({
      headers: [
        {
          text: 'Isbn',
          value: 'isbn',
          width: '120px'
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Band',
          value: 'volumeNames',
        },
        {
          text: 'Aktionen',
          value: 'actions',
        },
      ],
      search: undefined,
    })

    const editDialogOpen = ref(false)
    const selectedTextbookIssue = ref(null)
    const { getters, actions } = useTextbookStore()
    const { hasPermissionTo } = useUserStore().getters
    const { textbooks, activeTextbook, loading } = getters
    const { deleteTextbookIssue, updateTextbookIssue, loadTextbooks } = actions
    const textbookIssues = computed(() =>
      activeTextbook.value ? activeTextbook.value.issues : []
    )
    const showCreateTextbookIssueDialog = ref(false)
    const showImportTextbookIssueDialog = ref(false)
    const showPreviewTextbookIssueDialog = ref(false)
    const loadingPreview = ref(false)
    const $alert = inject(alertSymbol) as Function
    const showCreateTextbookIssueDialogHandler = () => {
      showCreateTextbookIssueDialog.value = true
    }

    const editItem = (item: TextbookIssue) => {
      selectedTextbookIssue.value = item
      editDialogOpen.value = true
    }
    const deleteItem = async (item: TextbookIssue) => {
      await $alert({
        type: 'confirm',
        text: root.$t('textbookIssue.confirmDelete', {
          textbookIssueName: item.name,
        }),
      })
      await deleteTextbookIssue(item.id)
      $alert({
        type: 'success',
        text: root.$t('textbookIssue.deleted', {
          textbookIssueName: item.name,
        }),
      })
    }

    onBeforeMount(loadTextbooks)

    const onTextbookIssueCreated = (newTextbookIssue: TextbookIssue) => {
      const textbook = textbooks.value
        .filter((el: Textbook) => el.id === newTextbookIssue.textbookId)
        .pop()
      textbook.issues.push(newTextbookIssue)
      showCreateTextbookIssueDialog.value = false
    }

    const onTextbookIssueEdited = (newTextbookIssue: TextbookIssue) => {
      updateTextbookIssue(newTextbookIssue)
      selectedTextbookIssue.value = null
      editDialogOpen.value = false
    }

    const onTextbookIssueImported = () => {
      loadTextbooks()
    }

    return {
      ...toRefs(data),
      editItem,
      textbookIssues,
      editDialogOpen,
      selectedTextbookIssue,
      onTextbookIssueEdited,
      showCreateTextbookIssueDialog,
      showCreateTextbookIssueDialogHandler,
      onTextbookIssueCreated,
      textbooks,
      activeTextbook,
      deleteItem,
      loading,
      hasPermissionTo,
      CREATE_TEXTBOOK_ISSUE,
      EDIT_TEXTBOOK_ISSUE,
      DELETE_TEXTBOOK_ISSUE,
      PUBLISH_TEXTBOOK_ISSUE_LIVE,
      PUBLISH_TEXTBOOK_ISSUE_PREVIEW,
      PREVIEW_TEXTBOOK_ISSUE,
      formatTimestamp,
      pagination,
      showImportTextbookIssueDialog,
      showPreviewTextbookIssueDialog,
      onTextbookIssueImported,
      IMPORT_TEXTBOOK_ISSUE,
      previewLink,
      loadingPreview,
    }
  },
})
